import React, { ComponentProps, Fragment, useState } from 'react';
import { Trans } from 'react-i18next';

type QuantityPickerProps = {
  count: number;
  maxNumberOfAdditionalParticipants?: number;
  onCountChange: (newCount: number) => void;
};

const ParticipantsButton = (btnProps: ComponentProps<'button'>) => (
  <button
    {...btnProps}
    type="button"
    className="text-lg font-bold h-8 w-8 bg-primary-default text-primary-contrast rounded-full flex items-center justify-center"
  />
);

export function QuantityPicker({
  count,
  onCountChange,
  maxNumberOfAdditionalParticipants,
}: QuantityPickerProps) {
  const [showQuantityPicker, setShowQuantityPicker] = useState(count > 1);

  const increment = () => {
    const newCount = count + 1;
    onCountChange(newCount);
  };

  const decrement = () => {
    const newCount = Math.max(0, count - 1); // Prevent negative values
    onCountChange(newCount);
  };

  const handleShowQuantityPicker = () => {
    onCountChange(1);
    setShowQuantityPicker(true);
  };

  return (
    <Fragment>
      {showQuantityPicker ? (
        <div className="my-4">
          <h3 className="text-center opacity-30">
            <Trans>additional-participants</Trans>
          </h3>
          <div className="flex items-center justify-center">
            <ParticipantsButton onClick={decrement}>-</ParticipantsButton>
            <span className="mx-2">
              {count}
              {maxNumberOfAdditionalParticipants ? ` / ${maxNumberOfAdditionalParticipants}` : ''}
            </span>
            <ParticipantsButton onClick={increment}>+</ParticipantsButton>
          </div>
        </div>
      ) : (
        <div className={'text-center pb-4'}>
          <span role={'button'} className="mt-4 hover:underline" onClick={handleShowQuantityPicker}>
            + <Trans>add-more-guests</Trans>
          </span>
        </div>
      )}
    </Fragment>
  );
}
